import { ImageMetadata as ImageMetadataType } from '@exploration/shared-types';

// --------------------------------------------------------------------------

const getImageType = (url: string | undefined) => {
  if (!url) {
    return undefined;
  }
  // Regex just grabs the file extension at the end of the url
  const regex = /(?:\.([^.]+))?$/;
  const type = regex.exec(url)?.[1];
  if (!type) {
    return undefined;
  }
  switch (type) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    default:
      return undefined;
  }
};

export const ImageMetadataTags = ({ image }: { image?: ImageMetadataType }) => {
  const imageType = getImageType(image?.url);
  if (!image || !imageType) {
    return <meta name="twitter:card" content="summary" key="twitter:card" />;
  }

  return (
    <>
      <meta property="og:image" content={image.url} key={`og:image`} />
      <meta property="og:image:url" content={image.url} key={`og:image:url`} />
      <meta
        property="og:image:type"
        content={imageType}
        key={`og:image:type`}
      />
      {!!image?.height && (
        <meta
          property="og:image:height"
          content={`${image?.height}`}
          key={`og:image:height`}
        />
      )}
      {!!image?.width && (
        <meta
          property="og:image:width"
          content={`${image?.width}`}
          key={`og:image:width`}
        />
      )}
      {!!image?.alt && (
        <meta
          property="og:image:alt"
          content={image.alt}
          key={`og:image:alt`}
        />
      )}

      {!!image?.alt && (
        <meta
          name="twitter:image:alt"
          content={image.alt}
          key={`twitter:image:alt`}
        />
      )}
      <meta
        name="twitter:card"
        content="summary_large_image"
        key="twitter:card"
      />
    </>
  );
};
